// Allow switching Backend URL at runtime for debug
export const g = globalThis as typeof globalThis & {
  apiBaseurl: { set: (url: string) => void; get: () => string };
};

const apiBaseurlImpl = {
  set: (url: string): never => {
    g.localStorage?.setItem("BACKEND_BASEURL", url);
    g.location?.reload?.();
    throw new Error("Backend URL changed, reloading");
  },
  get: (): string =>
    g?.localStorage?.getItem("BACKEND_BASEURL") ?? import.meta.env.VITE_BACKEND_BASEURL ?? "",
};

g.apiBaseurl = apiBaseurlImpl;
export const apiBaseurl = apiBaseurlImpl;
